import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ProfileService } from '../users/profile.service';
import { ProfileState } from '../users/profile.state';

import DepositsTable from './components/deposits/deposits.component';
import WithdrawalsTableComponent from './components/withdrawals/withdrawals.component';

@Component({
  selector: 'history-page',
  templateUrl: './history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProfileState, ProfileService],
  imports: [
    NgClass,
    DepositsTable,
    WithdrawalsTableComponent,
    RouterLink
  ],
  host: { class: 'flex items-center justify-center w-full lg:px-[1.5rem]' }
})
export default class HistoryComponent {
  public readonly tabs = [{ key: 'deposits', value: $localize`:@@history.tabs.deposit:Пополнение`, icon: 'deposit' }, { key: 'withdraws', value: $localize`:@@history.tabs.withdraw:Вывод`, icon: 'withdraw' }];

  public currentTab = 'deposits';
}
